module.exports = __webpack_public_path__ + "static/img/图层48.ece337f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层48.png
// module id = v/tm
// module chunks = 0